import { call, put, takeEvery } from 'redux-saga/effects';

import {
    FETCH_TRAINING_STATUS_AGGREGATED_DATA,
    FETCH_TRAINING_STATUS_AGGREGATED_DATA_FETCHING,
    FETCH_TRAINING_STATUS_AGGREGATED_DATA_SUCCESS,
    FETCH_TRAINING_STATUS_AGGREGATED_DATA_FAIL,
    FETCH_TRAINING_STATUS_MOST_RECENT_DATA,
    FETCH_TRAINING_STATUS_MOST_RECENT_DATA_FETCHING,
    FETCH_TRAINING_STATUS_MOST_RECENT_DATA_SUCCESS,
    FETCH_TRAINING_STATUS_MOST_RECENT_DATA_FAIL,
    FETCH_TRAINING_STATUS_WEEKLY_DATA_FETCHING,
    FETCH_TRAINING_STATUS_WEEKLY_DATA_SUCCESS,
    FETCH_TRAINING_STATUS_WEEKLY_DATA_FAIL,
    FETCH_TRAINING_STATUS_WEEKLY_DATA
} from '../actions/ActionTypes';
import { gcApi } from '../config/axios';

// Workers
export function* fetchTrainingStatusAggregatedSaga(action) {
    const { userProfileId, calendarDate } = action;

    try {
        yield put({
            type: FETCH_TRAINING_STATUS_AGGREGATED_DATA_FETCHING
        });

        const response = yield call(gcApi.get, `/metrics-service/metrics/trainingstatus/aggregated/${calendarDate}`);

        yield put({
            type: FETCH_TRAINING_STATUS_AGGREGATED_DATA_SUCCESS,
            calendarDate: calendarDate,
            userProfileId: userProfileId,
            trainingStatusDaily: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_TRAINING_STATUS_AGGREGATED_DATA_FAIL,
            calendarDate: calendarDate,
            userProfileId: userProfileId,
            trainingStatusDaily: null
        });
    }
}

export function* fetchTrainingStatusDailySaga(action) {
    const { userProfileId, calendarDate } = action;

    try {
        yield put({
            type: FETCH_TRAINING_STATUS_MOST_RECENT_DATA_FETCHING
        });

        const response = yield call(gcApi.get, `/metrics-service/metrics/trainingstatus/daily/${calendarDate}`);

        yield put({
            type: FETCH_TRAINING_STATUS_MOST_RECENT_DATA_SUCCESS,
            calendarDate: calendarDate,
            userProfileId: userProfileId,
            trainingStatusDaily: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_TRAINING_STATUS_MOST_RECENT_DATA_FAIL,
            calendarDate: calendarDate,
            userProfileId: userProfileId,
            trainingStatusDaily: null
        });
    }
}

export function* fetchTrainingStatusReportSaga(action) {
    const { displayName, startDate, endDate } = action.payload;

    try {
        yield put({
            type: FETCH_TRAINING_STATUS_WEEKLY_DATA_FETCHING
        });

        const response = yield call(
            gcApi.get,
            `/metrics-service/metrics/trainingstatus/weekly/${displayName}?fromCalendarDate=${startDate}&toCalendarDate=${endDate}`
        );

        yield put({
            type: FETCH_TRAINING_STATUS_WEEKLY_DATA_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_TRAINING_STATUS_WEEKLY_DATA_FAIL,
            data: null
        });
    }
}

// Watchers
export const trainingStatusSagas = [
    takeEvery(FETCH_TRAINING_STATUS_AGGREGATED_DATA, fetchTrainingStatusAggregatedSaga),
    takeEvery(FETCH_TRAINING_STATUS_MOST_RECENT_DATA, fetchTrainingStatusDailySaga),
    takeEvery(FETCH_TRAINING_STATUS_WEEKLY_DATA, fetchTrainingStatusReportSaga)
];
